module.exports = __webpack_public_path__ + "static/p13_cencerro-1a728cf8291829509e2adee9348b3877.png";